import Vue from 'vue'
import Vuex from 'vuex'

import admin from './modules/admin'
import copy from './modules/copy'
import logo from './modules/logo'
import main from './modules/main'
import usuarios from './modules/usuarios'
import info from './modules/info'
import suscripciones from './modules/suscripciones'
import personalizacion from './modules/personalizacion'
import categories from './modules/categories'
import atributos from './modules/atributos'
import statistics from './modules/statistics'
import slides from './modules/slides'
import sociales from './modules/sociales'
import secciones from './modules/secciones'
import categoryType from './modules/categoryType'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    copy,
    logo,
    main,
    usuarios,
    info,
    suscripciones,
    personalizacion,
    categories,
    atributos,
    statistics,
    slides,
    sociales,
    secciones,
    categoryType,
  }
})
